import React, { useEffect, useState } from "react";
import { Waves } from "@phosphor-icons/react";
import { fetchDebrisFlowRisk } from "../lib/api";

const fmtWindow = (iso) =>
  new Date(iso).toLocaleString([], { weekday: "short", hour: "numeric" });

export default function DebrisFlowNotice({ fireName }) {
  const [risk, setRisk] = useState(null);

  useEffect(() => {
    if (!fireName) return;
    fetchDebrisFlowRisk()
      .then((d) => {
        const hit = (d.at_risk || []).find(
          (s) => (s.name || "").toLowerCase() === fireName.toLowerCase(),
        );
        setRisk(hit || null);
      })
      .catch(() => setRisk(null));
  }, [fireName]);

  if (!risk) return null;
  const elevated = risk.risk_level === "elevated";
  const color = elevated ? "#E63946" : "#F59E0B";

  return (
    <div
      className="border px-4 py-3 flex items-start gap-3"
      style={{ borderColor: `${color}66`, background: `${color}12` }}
      data-testid="debris-flow-notice"
    >
      <Waves size={18} weight="duotone" style={{ color }} className="mt-0.5 shrink-0" />
      <div>
        <div className="text-[13px] font-bold uppercase tracking-wider" style={{ color }}>
          {elevated ? "Elevated debris-flow risk" : "Debris-flow advisory"} — burn scar rain
        </div>
        <div className="text-[13px] text-tac-dim leading-snug mt-0.5">
          Up to {risk.peak_6h_in}" of rain in 6 hrs is forecast over this burn scar
          ({risk.max_pop}% chance, around {fmtWindow(risk.window_start)}). Mudflows and flash
          flooding are possible in and below the burn area. Advisory only — follow county EM.
        </div>
      </div>
    </div>
  );
}
